/** Represents various attributes of a custom attribute type. */
export const customAttributeTypeAttributes = {
    text: {
        label: 'Text',
        icon: 'input',
    },
    select: {
        label: 'Select',
        icon: 'dropdown-list',
    },
};
